const API_URL = import.meta.env.VITE_API_URL ?? "";

export class ApiError extends Error {
  status: number;
  body: string;

  constructor(status: number, body: string) {
    super(`API ${status}: ${body}`);
    this.name = "ApiError";
    this.status = status;
    this.body = body;
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
  if (!res.ok) {
    throw new ApiError(res.status, await res.text());
  }
  if (res.status === 204) {
    return undefined as T;
  }
  return res.json();
}

export async function apiFull<T>(
  path: string,
  init?: RequestInit,
): Promise<{ data: T; headers: Headers }> {
  const res = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...init?.headers,
    },
  });
  if (!res.ok) {
    throw new ApiError(res.status, await res.text());
  }
  const data: T = res.status === 204 ? (undefined as T) : await res.json();
  return { data, headers: res.headers };
}

// OAuth start is a full-page navigation, so it must target the API origin —
// a relative URL resolves against the SPA host and just re-renders the app.
export function oauthStartUrl(
  provider: string,
  params: URLSearchParams,
  apiUrl: string = API_URL,
): string {
  return `${apiUrl}/api/v2/identity/oauth/${provider}/start?${params.toString()}`;
}
